<button
  mat-fab
  color="primary"
  class="fab fab-fixed-right"
  (click)="addBus()"
  *ngIf="!itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <mat-icon>add</mat-icon>
</button>

<app-empty-list-message
  *ngIf="itinerary.reservations.buses.length == 0"
  message="Per questo itinerario non è ancora stato inserito alcun autobus."
  actionIcon="add"
  actionLabel="Aggiungi un autobus"
  [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
  (actionClick)="addBus()"
>
</app-empty-list-message>

<mat-accordion>
  <mat-expansion-panel
    *ngFor="let bus of itinerary.reservations.buses; index as busId"
    [(expanded)]="expanded[busId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <mat-icon class="header-icon">directions_bus</mat-icon>
        <span class="header-title" fxFlex>
          <app-itinerary-reservations-transportation-form-title
            [transportation]="bus"
          ></app-itinerary-reservations-transportation-form-title>
        </span>
        <div class="header-actions">
          <button
            mat-icon-button
            matTooltip="Rimuovi questo autobus'"
            (click)="removeBus($event, bus)"
            *ngIf="
              !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
            "
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-itinerary-reservations-transportation-form
      [transportation]="bus"
      [transportationId]="busId"
      [stopsFormFieldLabel]="'Fermate'"
      [detailFormFieldLabel]="'fermata'"
      [showCodeFormField]="false"
      [npax]="itinerary.npax"
      [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
    >
    </app-itinerary-reservations-transportation-form>
  </mat-expansion-panel>
</mat-accordion>
